// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"11ec0aef","203":"062a3458","242":"4cb1c35a","243":"7f795ccc","515":"9b78df42","551":"4b441a0e","579":"fc719c1a","601":"7bca5c1f","852":"279799a7","861":"1f9e51c4"}[chunkId] + ".chunk.js";
};